import React from "react";

const Footer = () => {
  return (
    <footer className="bg-header text-white text-center py-4 mt-6">
      © {new Date().getFullYear()} HaSo TuM Lab - IIT Ropar | All Rights Reserved
    </footer>
  );
};

export default Footer;